import React from "react";

import Lamina27img1 from "../images/lamina27img1.png";
import Lamina27img2 from "../images/lamina27img2.png";
import Lamina27actividad1 from "../images/lamina27actividad1.png";
import Lamina27actividad2 from "../images/lamina27actividad2.png";
import { Helmet } from "react-helmet";
import Button from "@material-ui/core/Button";

import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Banner from "../components/Banner";
import BannerFooter from "../components/BannerFooter";
import Title from "../components/Title";
import Actividad from "../components/Actividad";

const useStyles = makeStyles((theme) => ({
  contentLamina: {
    "& img": {
      maxWidth: "100%",
      margin: "0 auto",
    },
    "& p": {
      lineHeight: 1.5,
    },
    margin: "2em auto 4em",
  },
  purple: {
    color: theme.palette.purple.main,
    borderColor: theme.palette.purple.main,
  },
  root: {
    textAlign: "center",
    "& p": {
      textAlign: "left",
    },
    "& li": {
      textAlign: "left",
    },
    [theme.breakpoints.down("sm")]: {
      "& img": {
        width: "100%",
      },
    },
  },
}));

const Lamina27 = () => {
  const classes = useStyles();
  return (
    <>
      <Helmet
        title="Ciudadanía activa - Lámina 27: ¿Qué hace el poder judicial?"
        meta={[
          {
            property: "og:title",
            content: "Lámina 27: ¿Qué hace el poder judicial?",
            dataReactHelmet: true,
          },
          {
            property: "description",
            content:
              "El Poder Judicial es el encargado de administrar justicia en la sociedad.",
            dataReactHelmet: true,
          },
        ]}
      />
      <Banner number="27" color="purple" />

      <Container maxWidth="md" className={classes.contentLamina}>
        <Grid
          container
          className={classes.root}
          spacing={1}
          alignItems="center"
          justify="center"
        >
          <Grid item lg={7} md={7} sm={7} xs={12}>
            <Title
              title="¿Qué hace el poder judicial?"
              color="purple"
              size="md"
            />
          </Grid>
          <Grid item lg={5} md={5} sm={5} xs={12}>
            <img src={Lamina27img1} alt="¿Qué hace el poder judicial?" />
          </Grid>
        </Grid>
      </Container>

      <Container maxWidth="md" className={classes.contentLamina}>
        <Actividad color="purple" />
        <p>
          <strong>Observa la siguiente situación:</strong>
        </p>
        <img src={Lamina27img2} alt="Actividad" />
        <p>
          <strong>
            Conversa con un familiar: ¿los ciudadanos y ciudadanas pueden hacer
            lo que se muestra? ¿Por qué? ¿Qué autoridad debería impartir
            justicia?
          </strong>
        </p>

        <Grid container className={classes.root} spacing={4} justify="center">
          <Grid item lg={7} md={7} sm={7} xs={12}>
            <p>
              El Poder Judicial es el encargado de administrar justicia en la
              sociedad y tiene entre sus funciones las siguientes:
            </p>
            <ul>
              <li>Castigar a quien comete delitos.</li>
              <li>Resolver conflictos entre las personas.</li>
              <li>Defender a las personas cuando se afectan sus derechos.</li>
            </ul>
          </Grid>
          <Grid item lg={5} md={5} sm={5} xs={12}>
            <p style={{ color: "#ec008c" }}>
              <strong>
                Pero promover justicia es también tarea de todos. En cada acción
                que se nos presenta a diario, respetemos el derecho de las
                personas, busquemos soluciones creativas, justas y pacíficas a
                nuestras necesidades. No olvides que tu derecho termina cuando
                empieza el de los demás.
              </strong>
            </p>
          </Grid>
        </Grid>
      </Container>

      <Container maxWidth="md" className={classes.contentLamina}>
        <Actividad color="purple" />
        <p>
          <strong>Lee el siguiente texto:</strong>
        </p>
        <img src={Lamina27actividad1} alt="Actividad" />
        <p>
          <strong>
            Ahora observa la imagen de la Dama de la Justicia e identifica el
            significado de cada uno de sus elementos colocando en los recuadros
            alguna de las oraciones resaltadas en el texto de arriba.
          </strong>
        </p>
        <img src={Lamina27actividad2} alt="Actividad" />
        <p>
          <strong>
            Conversa con un familiar y responde de forma escrita o grabando un
            audio.
          </strong>
        </p>
        <p>
          ¿Por qué es importante que la justicia tenga estas características?
          ¿Qué proble- mas pueden suceder cuando no se respeta o no se cumple
          alguna de ellas?
        </p>
      </Container>

      <Container maxWidth="md" className={classes.contentLamina}>
        <p>Descargar lámina aquí:</p>
        <Button
          href="https://fundacionmohme.org/wp-content/uploads/2020/07/Ciudadanía-Activa-Lámina-27.pdf"
          rel="noopener noreferrer"
          target="_blank"
          variant="outlined"
          classes={{ root: classes.purple }}
          className="btn-download"
          onClick={() => { window.dataLayer.push({
            'lamina': 'Lámina 27: ¿Qué hace el poder judicial?'
          }); }}
        >
          Descargar
        </Button>
      </Container>
      <BannerFooter
        active={true}
        anterior="¿Qué hace el congreso?"
        anteriorEnlace="/lamina-1-26"
        siguiente="Los símbolos que representan al Perú"
        siguienteEnlace="/lamina-1-28"
      />
    </>
  );
};

export default Lamina27;
